import { combineReducers } from "@reduxjs/toolkit";
import userReducer from "./user";
import systemReducer from "./system";
import formReducer from "./form";

export default combineReducers({
  user: userReducer,
  system: systemReducer,
  form: formReducer,
});
